import Vue from "vue";
import App from "./App.vue";

import "./assets/scss/main.scss";

import VueRouter from "vue-router";
import VueLazyload from "vue-lazyload";
import router from "./router";
import VueContentPlaceholders from "vue-content-placeholders";

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading:
    "https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/static/assets/loader.gif",
  attempt: 1,
});

// Helper function to get URL parameters
function getUrlParameter(name) {
  // Check standard query string
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has(name)) return urlParams.get(name);

  // Check hash fragment (for #/?foo=bar)
  if (window.location.hash) {
    // Remove leading #/ or #
    const hash = window.location.hash.replace(/^#\/?/, '');
    const hashParams = new URLSearchParams(hash);
    if (hashParams.has(name)) return hashParams.get(name);
  }
  return null;
}

// Helper function to get and store persistent values
function getPersistentValue(urlParamName, localStorageKey, dataAttribute, defaultValue) {
  // First, check URL parameters
  const urlValue = getUrlParameter(urlParamName);
  if (urlValue) {
    // Store in localStorage for persistence
    localStorage.setItem(localStorageKey, urlValue);
    return urlValue;
  }
  
  // Second, check localStorage for previously stored value
  const storedValue = localStorage.getItem(localStorageKey);
  if (storedValue) {
    return storedValue;
  }
  
  // Finally, fall back to data attribute or default value
  const app = document.getElementById("app");
  return app.getAttribute(dataAttribute) || defaultValue;
}

let app = document.getElementById("app");

// Get siteId and ctaUrl from URL params first, then localStorage, then data attributes
const siteId = getPersistentValue("siteId", "utd-siteId", "data-site-id", "");
const ctaUrl = getPersistentValue("ctaUrl", "utd-ctaUrl", "data-cta-url", "#");
const baseUrl = getPersistentValue("baseUrl", "utd-baseUrl", "data-base-url", "");
const noHeader = getPersistentValue("noHeader", "utd-noHeader", "data-no-header", "false");

// Get other values from data attributes as before
const lang = app.getAttribute("data-lang") || "nl";
// Get API endpoint from data attribute or environment
const apiUrl = app.getAttribute("data-api-url") || process.env.VUE_APP_API_URL || "http://localhost:3001";
// Get labels to hide from display (comma-separated)
const hideLabels = app.getAttribute("data-hide-labels") || "";

console.log("🔧 Main.js debug - noHeader value:", {
  noHeader: noHeader,
  type: typeof noHeader,
  dataAttribute: app.getAttribute("data-no-header"),
  comparison: noHeader === "true"
});

const props = {
  page: app.getAttribute("data-page"),
  filters: app.getAttribute("data-filters")?.toLowerCase(),
  lang: lang.toLowerCase(),
  siteId: siteId,
  label: app.getAttribute("data-label") || "vakanties",
  ctaText: app.getAttribute("data-cta-text") || "Boek Nu",
  ctaUrl: ctaUrl,
  baseUrl: baseUrl,
  noHeader: noHeader,
  apiUrl: apiUrl,
  hideLabels: hideLabels.split(',').map(label => label.trim().toLowerCase()).filter(Boolean),
};

Vue.use(VueContentPlaceholders);
Vue.use(VueRouter);

Vue.config.productionTip = false;
Vue.prototype.shopSettings = props;

// Add utility methods for managing persistent values
Vue.prototype.updateSiteId = function(newSiteId) {
  localStorage.setItem("utd-siteId", newSiteId);
  this.shopSettings.siteId = newSiteId;
};

Vue.prototype.updateCtaUrl = function(newCtaUrl) {
  localStorage.setItem("utd-ctaUrl", newCtaUrl);
  this.shopSettings.ctaUrl = newCtaUrl;
};

Vue.prototype.updateBaseUrl = function(newBaseUrl) {
  localStorage.setItem("utd-baseUrl", newBaseUrl);
  this.shopSettings.baseUrl = newBaseUrl;
};

Vue.prototype.clearStoredValues = function() {
  localStorage.removeItem("utd-siteId");
  localStorage.removeItem("utd-ctaUrl");
  localStorage.removeItem("utd-baseUrl");
  // Reset to data attributes or defaults
  const app = document.getElementById("app");
  this.shopSettings.siteId = app.getAttribute("data-site-id") || "";
  this.shopSettings.ctaUrl = app.getAttribute("data-cta-url") || "#";
  this.shopSettings.baseUrl = app.getAttribute("data-base-url") || "https://selectair.blogspot.com";
};

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
